import { DATETIME_FORMAT } from 'constans/common'
import dayjs from 'dayjs'
export const formatDate = (val = '', formatString = DATETIME_FORMAT) => {
  return dayjs(new Date(val)).format(formatString)
}
